import { Button, Typography } from '@material-ui/core';
import React, { useState } from 'react';

export default function TermsScreen({
  name,
  onContinue,
  onBack,
}: {
  name: string;
  onContinue: () => void;
  onBack: () => void;
}) {
  const [aceito, setAceito] = useState(false);

  return (
    <div>
      <Typography variant="h5" className={"marginBottom: '1em'"}>
        Seja bem vindo(a) {name}!
      </Typography>

      <p>Esta vistoria será realizada via Teleatendimento, uma tecnologia da Ativa Brasil Perícias e Avaliações.</p>
      <p>
        Antes de continuar, leia nosso{' '}
        <a href="https://www.google.com" target="_BLANK" rel="noreferrer">
          termo de aceite
        </a>
        .
      </p>

      <label>
        <input type="checkbox" checked={aceito} onChange={e => setAceito(e.target.checked)} />
        Eu li e aceito os termos
      </label>

      <br />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1em' }}>
        <Button onClick={onBack} variant="outlined" color="primary">
          Voltar
        </Button>
        <Button onClick={onContinue} disabled={!aceito} variant="contained" color="primary">
          Continuar
        </Button>
      </div>
    </div>
  );
}
